import { combineReducers } from "redux";
import {
  authorization,
  profile,
  currentRoute,
  notifications,
  app,
  usersForm,
  users,
  alerts,
  alertsForm,
  currentTheme,
  tasks,
  tasksForm,
  projects,
  projectsForm,
  projectControls,
  projectControlsForm,
  projectTasks,
  projectTasksForm,
  workers,
  workersForm,
} from "./Reducers";

export default combineReducers({
  workers,
  workersForm,
  projects,
  projectsForm,
  projectControls,
  projectControlsForm,
  projectTasks,
  projectTasksForm,
  tasks,
  tasksForm,
  app,
  authorization,
  currentRoute,
  profile,
  notifications,
  usersForm,
  users,
  alerts,
  alertsForm,
  currentTheme,
});
